import '@babel/polyfill'

import Vue from 'vue'

import 'bulma'

import store from'./scripts/store.js'
import router from'./scripts/router.js'
import useGtm from'./scripts/useGtm.js'

/*
router.beforeEach((to,from,next) => {
  console.log(performance.navigation.type)
  console.log(to,from)
  next()
})
router.afterEach((to,from) => {
  console.log(to,from)
})
*/

import * as THREE from 'three'
//import 'three.js/node_modules/three/examples/js/controls/DeviceOrientationControls.js'
import 'three/examples/js/controls/DeviceOrientationControls.js'

window.THREE = THREE

useGtm(router)

window.app = new Vue({
	el: '#app',
  router,
  store,
})
